import styled from "styled-components";

const HomeCriminalsWrap = styled.div`
  padding: 12px 0;
`

export default HomeCriminalsWrap